import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=72c4d0ad&scoped=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c4d0ad",
  null
  
)

export default component.exports